import { render, staticRenderFns } from "./RelativeDateSelector.vue?vue&type=template&id=3557c9b1&scoped=true&"
import script from "./RelativeDateSelector.vue?vue&type=script&lang=js&"
export * from "./RelativeDateSelector.vue?vue&type=script&lang=js&"
import style0 from "./RelativeDateSelector.vue?vue&type=style&index=0&id=3557c9b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3557c9b1",
  null
  
)

export default component.exports